import axios from "axios";
import {getBackendURL, httpResponse, httpResponseError} from "./fn";

export const getClientsListData = async () => {
  const result = await new Promise((resolve) => {
    axios.get(`${getBackendURL()}/subject/list`, {
      withCredentials: true,
      headers: {
        'Accept': '*/*',
        'content-type': 'application/json'
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch((error) => {
      resolve(httpResponseError(error))
    });
  })

  return result;
}